export default class Timer {
  constructor (el) {
    this.el = el
    this.targetDate = new Date(this.el.getAttribute('data-date')).getTime();
    this.interval = null

    this.days = this.el.querySelector('.js-timer-days')
    this.hours = this.el.querySelector('.js-timer-hours')
    this.minutes = this.el.querySelector('.js-timer-minutes')
    this.seconds = this.el.querySelector('.js-timer-seconds')
  }

  init () {
    this.interval = setInterval(() => {

      const now = new Date().getTime()
    
      const distance = this.targetDate - now
    
      let days = Math.floor(distance / (1000 * 60 * 60 * 24))
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((distance % (1000 * 60)) / 1000)
      
      if (distance < 0) {
        clearInterval(this.interval)
        this.interval = null

        days = 0
        hours = 0
        minutes = 0
        seconds = 0
      }
      
      this.days.innerHTML = days.toString().padStart(2, '0')
      this.hours.innerHTML = hours.toString().padStart(2, '0')
      this.minutes.innerHTML = minutes.toString().padStart(2, '0')
      this.seconds.innerHTML = seconds.toString().padStart(2, '0')
      
      this.timerPlural(days, 0)
      this.timerPlural(hours, 1)
      this.timerPlural(minutes, 2)
      this.timerPlural(seconds, 3)

      
    }, 1000);
  }

  timerPlural ( number, index ) {
    if (number < 0) return
    const keys = [2, 0, 1, 1, 1, 2];
    const mod = number % 100;
    const suffix_key = (mod > 7 && mod < 20) ? 2: keys[Math.min(mod % 10, 5)];
    const textEl = this.el.querySelectorAll('.js-timer-text');
    const textElNodes = textEl[index].querySelectorAll('span');
    textElNodes.forEach( el => el.classList.remove('active') );
    textElNodes[suffix_key].classList.add('active');
  }
}
